export default {"src":"/_next/static/media/Featured2.72cb9c07.svg","height":56,"width":56};